import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import DataLoader from '../../app/DataLoader';
import { Card, Grid } from '@material-ui/core';
import { signout } from '../../redux/actions/userActions';
import uuid from 'uuid';
import healthIcon from '../../img/assessment/health.png';
import shieldIcon from '../../img/assessment/shield.png';
import globeIcon from '../../img/assessment/globe-locked.png';
import clockIcon from '../../img/assessment/clock.svg';
import '../../scss/component/assessments/new-assessment.scss';

class Assessment extends React.Component {
    state = {
      isActive: true,
      loading: true,
      loaded: false,
      cards: [
        {
          icon: healthIcon,
          path: "/app/assessment/hipaa-assessment",
          title: "HIPAA Compliance Assessment",
          description: "For businesses within the healthcare or health-tech sector and people who handle or process health data.",
          time: "5 mins"
        },
  
        {
          icon: shieldIcon,
          path: "/app/assessment/cmmc-assessment",
          title: "CMMC Compliance Assessment",
          description: "For current and prospective contractors with the Department of Defense.",
          time: "7 mins"
        },
  
        {
          icon: globeIcon,
          path: "/app/assessment/nist-assessment",
          title: "NIST CSF Assessment",
          description: "Measure your organization's security program maturity and potential security risks.",
          time: "8 mins"
        },
  
        {
          icon: healthIcon,
          path: "/app/assessment/iso9001-assessment",
          title: "ISO 9001 Compliance Assessment",
          description: "For businesses looking to establish a quality management system for their products and services.",
          time: "5 mins"
        }
      ],
    }


  render() {
    return (
      <DataLoader>
        <div>
          <div>
            <Row>
              <Col md={12}>
                <div id="title">CHOOSE AN ASSESSMENT</div>
                <div id="description">
                  Select the assessment that best applies to you.
                </div>
              </Col>
            </Row>

            <Grid container>
              {this.state.cards.map(c => (
                <Grid item className="options" key={uuid()}>
                  <Card className="option"
                    onClick={() => {this.props.history.push(c.path);
                    }}
                  >
                    <div className="text">
                      <div className="title">
                        <img src={c.icon} alt="" className="image"/>
                        <div className="compliance">{c.title}</div>
                      </div>
                      <div className="description">
                        {c.description}
                      </div>
                      <div className="time">
                        <img src={clockIcon} alt="" className="image"/>
                        <span id="minutes">{c.time}</span>
                      </div>
                    </div>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </div>
        </div >
      </DataLoader>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    tenant: state.auth.tenant,
    enabledFrameworks: state.controlsData.enabledFrameworks,
    dataLoaded: !state.controlsData.loading,
    sidebar: state.sidebar
  }
}

export default connect(mapStateToProps, { signout })(withRouter(Assessment))


// WEBPACK FOOTER //
// ./src/components/assessment/Assessment.js